import { APP_TOGGLE_MENU, APP_TOGGLE_NOTIFICATION_CENTER, AppActionTypes } from './types'

export interface IAppState {
  openMenu: boolean
  openNotificationCenter: boolean
}

const defaultState: IAppState = {
  openMenu: window.innerWidth <= 1100 ? false : true,
  openNotificationCenter: false,
}

const notification = (state: IAppState = defaultState, action: AppActionTypes): IAppState => {
  switch (action.type) {
    case APP_TOGGLE_MENU:
      return { ...state, openMenu: !state.openMenu }
    case APP_TOGGLE_NOTIFICATION_CENTER:
      return { ...state, openNotificationCenter: !state.openNotificationCenter }
    default:
      return state
  }
}

export default notification
